export default (state = [], action) => {
	switch (action.type) {
	  case 'SET_MENU':
		return action.payload
	  default:
		return state
	}
  }
  


// WEBPACK FOOTER //
// ./src/reducers/menu.js